import { render, staticRenderFns } from "./TrendsCard.vue?vue&type=template&id=70c423b1&scoped=true"
import script from "./TrendsCard.vue?vue&type=script&lang=js"
export * from "./TrendsCard.vue?vue&type=script&lang=js"
import style0 from "./TrendsCard.vue?vue&type=style&index=0&id=70c423b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c423b1",
  null
  
)

export default component.exports